// extracted by mini-css-extract-plugin
export var desktopLayout = "MasonryGridPanel-module--desktopLayout--62d62";
export var heading = "MasonryGridPanel-module--heading--82716";